const employeeList = [
    {
        empId: 1,
        image: require('@/assets/images/users/avatar-2.jpg'),
        name: 'Siddhart Franklin',
        message: 'demoemail@gmail.com',
        time: '05 min',
        color: 'secondary'  
    },
    {
        empId: 2,
        image: require('@/assets/images/users/avatar-3.jpg'),
        name: 'Adam Miller',
        message: 'demoemail@gmail.com',
        time: '12 min',
        color: 'success'
    },
    {
        empId: 3,
        name: 'Keith Gonzales',
        message: 'demoemail@gmail.com',
        time: '24 min',
        color: 'success'
    },
    {
        empId: 4,
        image: require('@/assets/images/users/avatar-4.jpg'),
        name: 'Jose Vickery',
        message: 'demoemail@gmail.com',
        time: '1 hr',
        color: 'warning'
    },
    {
        empId: 5,
        name: 'Mitchel Givens',
        message: 'demoemail@gmail.com',
        time: '3 hrs',
        color: 'secondary'
    },
    {
        empId: 6,
        image: require('@/assets/images/users/avatar-4.jpg'),
        name: 'Stephen Hadley',
        message: 'demoemail@gmail.com',
        time: '5 hrs',
        color: 'success'
    },
    {
        empId: 7,
        image: require('@/assets/images/users/avatar-2.jpg'),
        name: 'Leord Joseph',
        message: 'demoemail@gmail.com',
        time: '24 min',
        color: 'success'
    },
    {
        empId: 8,
        image: require('@/assets/images/users/avatar-2.jpg'),
        name: 'Steven Franklin',
        message: 'demoemail@gmail.com',
        time: '05 min',
        color: 'secondary'  
    },
    {
        empId: 9,
        image: require('@/assets/images/users/avatar-3.jpg'),
        name: 'Adam Miller',
        message: 'demoemail@gmail.com',
        time: '12 min',
        color: 'success'
    },
    {
        empId: 10,
        name: 'Keith Gonzales',
        message: 'demoemail@gmail.com',
        time: '24 min',
        color: 'success'
    },
    {
        empId: 11,
        image: require('@/assets/images/users/avatar-4.jpg'),
        name: 'Jose Vickery',
        message: 'demoemail@gmail.com',
        time: '1 hr',
        color: 'warning'
    },
    {
        empId: 12,
        name: 'Mitchel Givens',
        message: 'demoemail@gmail.com',
        time: '3 hrs',
        color: 'secondary'
    },
    {
        empId: 13,
        image: require('@/assets/images/users/avatar-4.jpg'),
        name: 'Stephen Hadley',
        message: 'demoemail@gmail.com',
        time: '5 hrs',
        color: 'success'
    },
    {
        empId: 14,
        image: require('@/assets/images/users/avatar-2.jpg'),
        name: 'Leord Joseph',
        message: 'demoemail@gmail.com',
        time: '24 min',
        color: 'success'
    },
    {
        empId: 15,
        image: require('@/assets/images/users/avatar-4.jpg'),
        name: 'Stephen Hadley',
        message: 'demoemail@gmail.com',
        time: '5 hrs',
        color: 'success'
    },
    {
        empId: 16,
        image: require('@/assets/images/users/avatar-2.jpg'),
        name: 'Leord Joseph',
        message: 'demoemail@gmail.com',
        time: '24 min',
        color: 'success'
    },
    {
        empId: 17,
        name: 'Keith Gonzales',
        message: 'demoemail@gmail.com',
        time: '24 min',
        color: 'success'
    },
    {
        empId: 18,
        image: require('@/assets/images/users/avatar-4.jpg'),
        name: 'Jose Vickery',
        message: 'demoemail@gmail.com',
        time: '1 hr',
        color: 'warning'
    },
    {
        empId: 19,
        name: 'Mitchel Givens',
        message: 'demoemail@gmail.com',
        time: '3 hrs',
        color: 'secondary'
    },
    {
        empId: 20,
        image: require('@/assets/images/users/avatar-4.jpg'),
        name: 'Stephen Hadley',
        message: 'demoemail@gmail.com',
        time: '5 hrs',
        color: 'success'
    },
    {
        empId: 21,
        image: require('@/assets/images/users/avatar-2.jpg'),
        name: 'Leord Joseph',
        message: 'demoemail@gmail.com',
        time: '24 min',
        color: 'success'
    },
    {
        empId: 22,
        image: require('@/assets/images/users/avatar-2.jpg'),
        name: 'Steven Franklin',
        message: 'demoemail@gmail.com',
        time: '05 min',
        color: 'secondary'  
    },
    {
        empId: 23,
        image: require('@/assets/images/users/avatar-3.jpg'),
        name: 'Adam Miller',
        message: 'demoemail@gmail.com',
        time: '12 min',
        color: 'success'
    },
    {
        empId: 24,
        name: 'Keith Gonzales',
        message: 'demoemail@gmail.com',
        time: '24 min',
        color: 'success'
    },
    {
        empId: 25,
        image: require('@/assets/images/users/avatar-4.jpg'),
        name: 'Jose Vickery',
        message: 'demoemail@gmail.com',
        time: '1 hr',
        color: 'warning'
    },
    {
        empId: 26,
        name: 'Mitchel Givens',
        message: 'demoemail@gmail.com',
        time: '3 hrs',
        color: 'secondary'
    },
    {
        empId: 27,
        image: require('@/assets/images/users/avatar-4.jpg'),
        name: 'Stephen Hadley',
        message: 'demoemail@gmail.com',
        time: '5 hrs',
        color: 'success'
    },
    {
        empId: 28,
        image: require('@/assets/images/users/avatar-2.jpg'),
        name: 'Leord Joseph',
        message: 'demoemail@gmail.com',
        time: '24 min',
        color: 'success'
    },
    {
        empId: 29,
        image: require('@/assets/images/users/avatar-4.jpg'),
        name: 'Stephen Hadley',
        message: 'demoemail@gmail.com',
        time: '5 hrs',
        color: 'success'
    },
    {
        empId: 30,
        image: require('@/assets/images/users/avatar-2.jpg'),
        name: 'Leord Joseph',
        message: 'demoemail@gmail.com',
        time: '24 min',
        color: 'success'
    },
    {
        empId: 31,
        image: require('@/assets/images/users/avatar-3.jpg'),
        name: 'Adam Miller',
        message: 'demoemail@gmail.com',
        time: '12 min',
        color: 'success'
    },
];

export { employeeList };